import React from 'react';
import { InputCard } from '@components/cards';
import { RADIO } from '@components/cards/input-card/src/input-card.type';
import { EventChannel } from '@domain/channel';

import { ChannelListProps } from './channel-list.type';

export const ChannelList = ({
  channels,
  selectedChannel,
  handleChange,
  channelSearchValue,
  showDisabled,
}: ChannelListProps) => {
  const filterChannels = (channel: EventChannel) => {
    const searchFilter =
      channelSearchValue === '' || channel.channel.name.toLowerCase().includes(channelSearchValue.toLocaleLowerCase());
    const disabledFilter = channel.isEnabled || showDisabled;
    return disabledFilter && searchFilter;
  };
  return (
    <div className='px-2 flex flex-col gap-2 mt-6'>
      {channels
        ?.filter((channel) => filterChannels(channel))
        .map((channel) => {
          const isChecked = channel.channel.id === selectedChannel?.id;
          const inputCardContent = (
            <div className=''>
              <p className='text-primary text-subtitle-m text-left'>{channel.channel.name}</p>
              <p className='text-secondary text-body-s text-left'>{channel.channel.slug}</p>
            </div>
          );

          const handleChannelClick = () => {
            handleChange(channel.channel);
          };
          return (
            <InputCard
              key={channel.channel.id}
              isChecked={isChecked}
              isDisabled={!channel.isEnabled}
              type={RADIO}
              handleClick={handleChannelClick}>
              {inputCardContent}
            </InputCard>
          );
        })}
    </div>
  );
};
